import React, { useContext } from "react";

/* contexts for hooks */
import { ChartDataContext } from "../../context/ChartDataContext";
import { UIContext } from "../../context/UIContext";

import "./ColorBar.scss";

const ColorBar = () => {
  const { selectedOverlayData } = useContext(ChartDataContext);
  const { isTouchScreen } = useContext(UIContext);

  const overlayColors = {
    Significant_wave_height_of_combined_wind_waves_and_swell: {
      class: "colorbar-wave",
      high: 15,
      middle: 7.5,
      low: 0,
      measurement: "m"
    },
    Eastward_10_meter_wind_component: {
      class: "colorbar-wind",
      high: 40,
      middle: 20,
      low: 0,
      measurement: "m/s"
    },
    Magnitude_water_velocity: {
      class: "colorbar-current",
      high: 2,
      middle: 1,
      low: 0,
      measurement: "m/s"
    }
  };

  return (
    <div
      className={
        isTouchScreen ? "colorbar-container-mobile" : "colorbar-container"
      }
    >
      <span
        style={{
          color: "#FFF",
          fontSize: "0.7em",
          position: "absolute",
          left: "17.5px",
          top: "0.5vh"
        }}
      >
        {overlayColors[selectedOverlayData.selectedVariable.name].high}
        {overlayColors[selectedOverlayData.selectedVariable.name].measurement}
      </span>
      <div
        className={`colorbar ${
          overlayColors[selectedOverlayData.selectedVariable.name].class
        }`}
      ></div>
      <span className="center-measurement">
        {overlayColors[selectedOverlayData.selectedVariable.name].middle}
        {overlayColors[selectedOverlayData.selectedVariable.name].measurement}
      </span>
      <span
        style={{
          color: "#FFF",
          fontSize: "0.7em",
          position: "absolute",
          left: "20px",
          bottom: "0.5vh"
        }}
      >
        {overlayColors[selectedOverlayData.selectedVariable.name].low}
        {overlayColors[selectedOverlayData.selectedVariable.name].measurement}
      </span>
    </div>
  );
};

export default ColorBar;
